import JSZip from 'jszip';
import { Archive } from 'libarchive.js';

export interface ArchiveEntry {
  path: string;
  data: Blob;
}

Archive.init({
  workerUrl: '/libarchive/worker-bundle.js',
});

export async function readArchive(file: File): Promise<ArchiveEntry[]> {
  const ext = file.name.split('.').pop()?.toLowerCase();

  if (ext === 'zip') {
    return readZip(file);
  }
  return readWithLibarchive(file);
}

async function readZip(file: File): Promise<ArchiveEntry[]> {
  const zip = await JSZip.loadAsync(file);
  const entries: ArchiveEntry[] = [];

  const promises = Object.keys(zip.files).map(async (path) => {
    const entry = zip.files[path];
    if (entry.dir) return;
    const blob = await entry.async('blob');
    entries.push({ path, data: blob });
  });

  await Promise.all(promises);
  return entries;
}

async function readWithLibarchive(file: File): Promise<ArchiveEntry[]> {
  const archive = await Archive.open(file);
  const filesObj = await archive.extractFiles();
  const entries: ArchiveEntry[] = [];

  function traverse(obj: Record<string, unknown>, prefix: string) {
    for (const key of Object.keys(obj)) {
      const value = obj[key];
      if (value instanceof File) {
        entries.push({ path: prefix + key, data: value });
      } else if (value && typeof value === 'object') {
        traverse(value as Record<string, unknown>, prefix + key + '/');
      }
    }
  }

  traverse(filesObj as Record<string, unknown>, '');
  return entries;
}
